


















import { Component, Vue, Watch } from "vue-property-decorator";
import store from "@/store";
import { namespace, Getter, Action, State } from "vuex-class";

import Heartbeat from "@/components/heartbeat/Heartbeat.vue";
import SureViewIcon from "@/components/SureViewIcon.vue";
import regionalInterceptors from "./services/axios.regional.interceptors";
import { RootState } from "./store/types";

// ENV variables available at runtime like so:
// console.log(process.env);
// @ref https://cli.vuejs.org/guide/mode-and-env.html

@Component({
	components: {
		heartbeat: Heartbeat,
		"sureview-icon": SureViewIcon
	}
})
export default class ImmixCloudAppV2 extends Vue {
	@State((state: RootState) => state.loading) private loading: boolean;
	@State((state: RootState) => state.User.dbFederationEnabled) private federationEnabled: boolean;

	@Getter private isLoggedIn: boolean;
	@Action private loadFeaturesList: () => Promise<void>;

	/**
	 * Watches for changes to the dbFederationEnabled flag. Ensures the regional request interceptors for axios are
	 * applied and removed correctly.
	 */
	@Watch("federationEnabled", { immediate: true })
	private onFederationEnabledChanged(newValue: boolean, oldValue: boolean) {
		if (newValue) {
			regionalInterceptors.applyInterceptors();
		} else {
			regionalInterceptors.removeInterceptors();
		}
	}

	/**
	 * Watches for route changes. If the route requires access to the features list, it will be fetched from the
	 * data service.
	 */
	@Watch("$route")
	private async onRouteChange(to, from) {
		let loadFeatures = true;

		if (
			to.hasOwnProperty("meta") &&
			to.meta.hasOwnProperty("loadFeatures") &&
			typeof to.meta.loadFeatures === "boolean"
		) {
			loadFeatures = to.meta.loadFeatures;
		}

		if (loadFeatures) {
			if (this.isLoggedIn) {
				// Call and get featureList from the cache.
				await this.loadFeaturesList();
			}
		}
	}
}
